import { EmployeeGroup } from "@/Common/Api/Employee/Dto/EmployeeGroup";
import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { Person } from "@/Common/Models/Person/Person";
import { IComboOrServiceItem } from "@/Common/Models/Services/BaseServiceDefinitionModel";
import { ServiceDefinitionModel } from "@/Common/Models/Services/ServiceDefinitionModel";
import { ServiceOrComboTableItem } from "@/Common/Models/Services/ServiceOrComboTableItem";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";

class EmployeeGroupUIModel {
    public Id: string;
    public Name: string;
    public IsInactive: boolean;
    public Model: EmployeeGroup;
    public ServicesCombos: ServiceOrComboTableItem<IComboOrServiceItem>[];
    public linkValid: boolean;

    constructor() {
        this.Id = "";
        this.Name = "";
        this.IsInactive = false;
        this.Model = new EmployeeGroup();
    }

    public clone(): EmployeeGroupUIModel {
        var groupModelClone: EmployeeGroup = JSON.parse(JSON.stringify(this.Model));
        return EmployeeGroupUIModel.fromCompositeObject(groupModelClone);
    }

    public static fromCompositeObject(groupComposite: EmployeeGroup): EmployeeGroupUIModel {
        var o = new EmployeeGroupUIModel();
        o.Model = groupComposite;
        if (groupComposite != null) {
            o.Id = groupComposite.Id;
            o.Name = groupComposite.Name;
            o.IsInactive = groupComposite.IsInactive;
        }

        o.refreshServiceCombos();

        return o;
    }

    public getSites(): SitesModel[] {
        let siteList: SitesModel[] = [];
        let siteFinder = function(id: string): SitesModel {
            return cacheStore.SiteCache.filter((s: SitesModel) => s.Model.Id === id)[0];
        };

        if (this.Model.SiteIds && this.Model.SiteIds.length > 0) {
            this.Model.SiteIds.forEach(x => {
                var site = siteFinder(x);
                if (!(site == null)) {
                    siteList.push(site);
                }
            });
        }
        return siteList;
    }

    public getAllClinicianByContactFacetId(): Person[] {
        let users: Person[] = [];

        if (this.Model.EmployeeContactFacetIds != null && this.Model.EmployeeContactFacetIds.length > 0) {
            for (let user of this.Model.EmployeeContactFacetIds) {
                users.push(cacheStore.GetCliniciansPersonsByContactFacetId(user));
            }
        }
        return users;
    }

    public refreshServiceCombos(): void {
        let group = this;
        group.ServicesCombos = [];
        let newCurrentEditedUserOfferedServices = (group.Model.ServicesIDsOffered != null && group.Model.ServicesIDsOffered.length > 0) ? group.Model.ServicesIDsOffered.map(x => x.DefId) : [];
        newCurrentEditedUserOfferedServices.forEach(x => {
            let foundService: ServiceDefinitionModel = ArrayHelper.Find(
                cacheStore.ServiceDefinitionCache.toArray(),
                (serviceModel: ServiceDefinitionModel) => serviceModel.Model.Id == x
            );

            if (foundService != null) {
                let service: ServiceOrComboTableItem<IComboOrServiceItem> =
                    new ServiceOrComboTableItem<ServiceDefinitionModel>(foundService);

                group.ServicesCombos.push(service);
            }
        });
    }

    public addNewServices(): void {
        let currentEditedUserOfferedServiceIds = this.ServicesCombos != null ? this.ServicesCombos.map(x => x.ServiceDefinitionId) : [];
        let newCurrentEditedUserOfferedServices = this.Model.ServicesIDsOffered != null ? this.Model.ServicesIDsOffered.map(x => x.DefId) : [];
        let toAdd = newCurrentEditedUserOfferedServices.filter(x => currentEditedUserOfferedServiceIds.indexOf(x) == -1);

        toAdd.forEach(x => {
            let foundService: ServiceDefinitionModel = ArrayHelper.Find(
                cacheStore.ServiceDefinitionCache.toArray(),
                (serviceModel: ServiceDefinitionModel) => serviceModel.Model.Id == x
            );

            if (foundService != null) {
                let service: ServiceOrComboTableItem<IComboOrServiceItem> =
                    new ServiceOrComboTableItem<ServiceDefinitionModel>(foundService);

                this.ServicesCombos.push(service);
            }
        });
    }

    public removeService(ServiceDefinitionId: string): void {
        let group = this;
        group.Model.ServicesIDsOffered = group.Model.ServicesIDsOffered.filter(x => x.DefId != ServiceDefinitionId);
        group.ServicesCombos = group.ServicesCombos.filter(x => x.ServiceDefinitionId != ServiceDefinitionId);
    }

    public getAggregatedTabNames(TabContext: string, lang: string): string[] {
        let textList = this.Model.ClickableText;
        // if (lang.toLowerCase().replace("-", "") === "esmx") lang = "esmx";
        let filteredTextList = textList.filter(x => x.Language === lang);
        let texts = filteredTextList.filter(x => x.Context === TabContext);
        let unique_array_textList = [];
        for (let text of texts) {
            if (unique_array_textList.indexOf(text) == -1)
                unique_array_textList.push(text);
        }
        return unique_array_textList;
    }

    public isLinkUrlValid(val: string): boolean {
        let urlMatchingPattern: RegExp;
        urlMatchingPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/;
        let isvalid = IsNullOrWhiteSpace(val);
        if (isvalid) return true;

        isvalid = urlMatchingPattern.test(val);
        this.linkValid = isvalid;
        return isvalid;
    }

    public getArrayAllowedTags(): Immutable.List<string> {
        let arrayAllowedTags: Immutable.List<string> = null;
        if (this.Model.AllowedTags != null && this.Model.AllowedTags.length > 0) {
            arrayAllowedTags = this.Model.AllowedTags[0].split("*").toImmutable();
        }
        return arrayAllowedTags;
    }

    public getCurrentTagNames(names: Immutable.List<string>): Immutable.List<number> {
        let tagIds: Immutable.List<number> = Immutable.List([]);
        if (names != null) {
            let currentTagIds = cacheStore.radPdfTagsCache.filter(kvp => names.indexOf(kvp.Value) !== -1).map(d => d.Key);
            tagIds = Immutable.List(currentTagIds);
        }
        return tagIds;
    }

    public addNewLink(newLink: string): void {
        let usefulLinkUrl: string[] = [];

        let url = this.Model.UsefulLinks;
        if (url != null && url.length > 0) {
            let parts = url[0].split(";");
            usefulLinkUrl = parts;
            if (!usefulLinkUrl.some(x => x.toString() == newLink.trim()))
                this.Model.UsefulLinks.push(newLink.trim());
        }
        else {
            this.Model.UsefulLinks = [];
            this.Model.UsefulLinks.push(newLink.trim());
        }
    }
}

export { EmployeeGroupUIModel };
